import React, { useState } from 'react';
import SimpleDialog, { SimpleDialogProps } from '../SimpleDialog/SimpleDialog';
import { SelectRadioButton } from '../../ui';
import { useTranslation } from 'react-i18next';
import { AppState } from '../../../store/state';
import { AppDispatch } from '../../../store/store';
import { DeleteAssignment } from '../../../store/review/types';
import assignmentSlice from '../../../store/review/slice';
import { connect } from 'react-redux';

interface Props extends Omit<SimpleDialogProps, 'handleOk'> {
  count: number;
  type: 'reviewer' | 'submission';
  handleOk: (withReviews: boolean) => void;
}

const DeleteAssignmentDialog: React.FC<Props> = ({ count, type, handleOk, ...rest }) => {
  const [withReviews, setWithReviews] = useState<string | undefined>(undefined);
  const { t, i18n } = useTranslation();

  let msg;
  switch (type) {
    case 'reviewer':
      msg = t('Are you sure you want to remove assignments of {{count}} reviewer(s)?', { count: count });
      break;
    case 'submission':
      msg = t('Are you sure you want to remove assignments of {{count}} submission(s)?', { count: count });
      break;
    default:
      msg = '';
  }

  return (
    <SimpleDialog
      {...rest}
      open={true}
      handleOk={() => handleOk(withReviews == 'yes')}
      title={t('Delete assignment') + '?'}
      disableOkButton={withReviews == undefined}
    >
      <div>
        <p>{msg}</p>
        <div className="mt-0.5">
          <p>{t('Some may contain reviews, delete them anyway?')}</p>
          <SelectRadioButton
            options={[
              { id: 'no', label: t('No, only delete those assignments without reviews.') },
              { id: 'yes', label: t('Yes') },
            ]}
            value={withReviews}
            onChange={setWithReviews}
            className="flex flex-col gap-y-1 mt-1"
          />
        </div>
      </div>
    </SimpleDialog>
  );
};

const mapStateToProps = (state: AppState) => ({});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  deleteAssignmentAction: (data: DeleteAssignment) => dispatch(assignmentSlice.actions['ASSIGNMENTS:DELETE'](data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DeleteAssignmentDialog);
